import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, Clock, Check } from 'lucide-react';
import { PageHeader } from '../PageHeader';
import { events } from '../data';
const typeColors: Record<string, string> = {
  Company: 'bg-navy-600 text-white',
  Training: 'bg-sage text-white',
  Culture: 'bg-gold-500 text-navy-900'
};
export function EventsPage() {
  const [rsvped, setRsvped] = useState<Record<string, boolean>>({});
  const [toast, setToast] = useState<string | null>(null);
  const toggle = (id: string) => {
    const isGoing = !rsvped[id];
    setRsvped(r => ({
      ...r,
      [id]: isGoing
    }));
    setToast(isGoing ? 'RSVP confirmed' : 'RSVP cancelled');
    setTimeout(() => setToast(null), 2000);
  };
  return <>
      <PageHeader title="Events" subtitle="Town halls, trainings, and culture events you won't want to miss." data-id="element-458" data-mp="1k9g0k7mj27k" />

      <div className="space-y-4 max-w-3xl relative" data-id="element-459" data-mp="6jmbtugh3jma">
        {events.map((e, i) => {
        const going = rsvped[e.id];
        return <motion.div key={e.id} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-white rounded-xl border border-navy-100 p-5 flex flex-col sm:flex-row gap-5" data-id="element-460" data-mp="2gajnvwfpcl1o" data-mpi={i}>
              <div className="w-16 shrink-0 text-center bg-navy-50 rounded-xl py-3 self-start" data-id="element-461" data-mp="2v3wwluq2rbzo">
                <div className="text-2xl font-bold text-navy-900 leading-none" data-id="element-462" data-mp="38yz06b7g8p9b">
                  {e.day}
                </div>
                <div className="text-xs font-bold text-gold-600 tracking-wide mt-1" data-id="element-463" data-mp="3iuslaiz8hr2p">
                  {e.month}
                </div>
              </div>
              <div className="flex-1 min-w-0" data-id="element-464" data-mp="3dy24ftflurg8">
                <span className={`inline-block text-[0.65rem] font-bold uppercase tracking-wide px-2 py-1 rounded-full mb-2 ${typeColors[e.type] || 'bg-navy-100 text-navy-700'}`} data-id="element-465" data-mp="3kzxk8lp225z2">
                  {e.type}
                </span>
                <h3 className="font-serif font-bold text-lg text-navy-900" data-id="element-466" data-mp="3uvs8pxfymv9r">
                  {e.title}
                </h3>
                <p className="text-sm text-navy-500 mt-1 mb-3" data-id="element-467" data-mp="8iagp1dgbp0b">
                  {e.description}
                </p>
                <div className="flex flex-wrap items-center gap-4 text-xs text-navy-400" data-id="element-468" data-mp="ciue861xsumz">
                  <span className="inline-flex items-center gap-1.5" data-id="element-469" data-mp="hi73syk70ft9">
                    <Clock className="w-3.5 h-3.5" data-id="element-470" data-mp="hgvu6i42gdu8" />
                    {e.time}
                  </span>
                  {e.location && <span className="inline-flex items-center gap-1.5" data-id="element-471" data-mp="2jb3mn7kcgmnx">
                      <MapPin className="w-3.5 h-3.5" data-id="element-472" data-mp="2o8wo5napcshv" />
                      {e.location}
                    </span>}
                </div>
              </div>
              <div className="self-center shrink-0" data-id="element-473" data-mp="2grgqhnro247o">
                <button onClick={() => toggle(e.id)} className={`inline-flex items-center justify-center gap-1.5 px-5 py-2.5 text-sm font-bold rounded-lg transition-colors w-full sm:w-auto ${going ? 'bg-sage text-white' : 'bg-gold-500 text-navy-900 hover:bg-gold-400'}`} data-id="element-474" data-mp="2bxvx6910pyet">
                  {going ? <>
                      <Check className="w-4 h-4" data-id="element-475" data-mp="2up59eq26b1a3" /> Going
                    </> : 'RSVP'}
                </button>
              </div>
            </motion.div>;
      })}
        <AnimatePresence data-id="element-476" data-mp="2kqplevyg084t">
          {toast && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0
        }} className="fixed bottom-6 right-6 bg-navy-900 text-white px-4 py-2 rounded-lg shadow-lg text-sm z-50" data-id="element-477" data-mp="1eboj88itqtps">
              {toast}
            </motion.div>}
        </AnimatePresence>
      </div>
    </>;
}